module.exports = __webpack_public_path__ + "static/media/1015185.b4af697e.jpg";